import { createAction } from 'typesafe-actions';
import IPlayerData from '../../Player/IPlayerData';
import { fetchConflicts } from './Action/DataConflict';

export enum DataConflictActionType {
    FETCH_CONFLICTS = 'fetchConflicts',
    START_FETCHING_CONFLICTS = 'startFetchingConflicts',
    SET_CONFLICTS = 'setConflicts',
    RESOLVE_CONFLICTS = 'resolveConflicts',
}

export const DataConflictActions = {
    fetchConflicts,
    startFetchingConflicts: createAction(
        DataConflictActionType.START_FETCHING_CONFLICTS
    ),
    setConflicts: createAction(
        DataConflictActionType.SET_CONFLICTS,
        resolve => (data: IPlayerData[]) => resolve<IPlayerData[]>(data)
    ),
    resolveConflicts: createAction(
        DataConflictActionType.RESOLVE_CONFLICTS,
        resolve => (data: IPlayerData) => resolve<IPlayerData>(data)
    ),
};
